import type { SemanticCOLORS } from 'semantic-ui-react';

import type { VulnerabilitySeverity } from './vulnerabilities.models';

export const VULNERABILITIES_TABLE_MAX_ROWS = 100;

export const ANCHORE_RANK = 'anchoreRank';

export const VULNERABILITY_SEVERITIES: VulnerabilitySeverity[] = [
  'Critical',
  'High',
  'Medium',
  'Low',
  'Negligible',
  'Unknown',
];

export const EPSS_THRESHOLDS = {
  High: 0.7,
  Medium: 0.4,
  Low: 0,
} as const satisfies Record<string, number>;

export const EPSS_COLORS = {
  High: 'red',
  Medium: 'orange',
  Low: 'yellow',
} as const satisfies Record<keyof typeof EPSS_THRESHOLDS, SemanticCOLORS>;
